import { render, staticRenderFns } from "./Coming soon.vue?vue&type=template&id=9b501cc8"
import script from "./Coming soon.vue?vue&type=script&lang=js"
export * from "./Coming soon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports